// components/modals/web-modals/TranslationIssuesModal.jsx

import BaseModalWeb from './BaseModalWeb';
import TranslationIssuesComponent from './components/TranslationIssuesComponent';

const TranslationIssuesModal = ({ isOpen, onRequestClose }) => {
  return (
    <BaseModalWeb
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Translation Issues Modal"
      className="ReactModal__Content modal--web modal--750px"
      overlayClassName="ReactModal__Overlay modal-overlay--web"
    >
      <TranslationIssuesComponent />
    </BaseModalWeb>
  );
};

export default TranslationIssuesModal;